/**
 * Date utility functions for consistent date handling.
 * Uses system date since the container environment has a fixed date.
 */

/**
 * Gets the current date (uses system date)
 * Returns a promise for consistency with async code
 */
export async function getRealCurrentDate() {
  return new Date();
}

/**
 * Synchronous function to get today's date at midnight
 */
export function getTodayMidnight() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

/**
 * Checks if two dates are the same day
 */
export function isSameDay(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  return d1.getTime() === d2.getTime();
}

/**
 * Checks if a date is in the future
 */
export function isInFuture(date, referenceDate = null) {
  const targetDate = new Date(date);
  const refDate = referenceDate ? new Date(referenceDate) : new Date();
  return targetDate > refDate;
}

/**
 * Initialize the date utility
 */
export async function initializeDateUtils() {
  // No-op for now, keeping for API compatibility
}
